import React from 'react';
import { Testimonials, PageFaq } from '../sections/RestSections';
import { reviewsFaqs } from '../mock';

export default function ReviewsPage() {
  return (
    <main className="page reviews-page">
      <section className="page-hero">
        <div className="wrap">
          <p className="eyebrow">Customer Reviews</p>
          <h1>What our customers say</h1>
          <p className="lede">Real feedback from Savannah homeowners and businesses. We&rsquo;re grateful for every review &mdash; and we&rsquo;d love to earn yours next.</p>
        </div>
      </section>
      <Testimonials full />
      <PageFaq title="Reviews FAQs" subtitle="About our ratings and how to share your experience." items={reviewsFaqs} testid="reviews-faqs" />
    </main>
  );
}
